import { Component, EventEmitter, Output, ElementRef, ViewChild, Input } from '@angular/core';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mergeMap';
import { DropDownListComponent, AutoCompleteComponent } from '@syncfusion/ej2-ng-dropdowns';
import { DataManager, Query, WebApiAdaptor } from '@syncfusion/ej2-data';
import { Brand } from '../../services/medispan/models/brand';
import { Dosage } from '../../services/medispan/models/dosage';
import { Drug } from '../../services/medispan/models/drug';
import { FormType } from '../../services/medispan/models/form-type';
import { DrugPricing } from '../../services/pharmacy-locator/models/drug-pricing';
import { PharmacyLocatorService } from '../../services/pharmacy-locator/pharmacy-locator.service';
import { ContentComponent } from '../../app/content/content.component';
import { DrugLookupServiceInterface } from './drug-lookup-service-interface.service';
import { DrugLookup } from '../../lib/shared/drug-lookup';

@Component({
    selector: 'pdmi-drug-lookup',
    templateUrl: './drug-lookup.component.html',
    styleUrls: ['./drug-lookup.component.css']
})
export class DrugLookupComponent {
    constructor(private master: ContentComponent, private drugLookupServiceInterface: DrugLookupServiceInterface, private pharmacyLocatorService: PharmacyLocatorService) {
    }

    @ViewChild('drugNameAutoComplete') drugNameAutoComplete: AutoCompleteComponent;
    @ViewChild('brandDDL') brandDDL: DropDownListComponent;
    @ViewChild('dosageDDL') dosageDDL: DropDownListComponent;
    @ViewChild('strengthDDL') strengthDDL: DropDownListComponent;
    @ViewChild('quantityTB') quantityTB: ElementRef;

    // region Properties
    drugLookup: DrugLookup;
    drugName: string;
    brand: string;
    dosages: Dosage[];
    strength: string;
    dosage: string;
    typeId: number;
    quantity: number;
    ndc: string;
    npi: string;
    awpUnitPrice: number;
    packageSize: number;
    cardholderId: string;
    groupId: string;
    drug: Drug;
    brands: Brand[];
    types: any[];
    disableBrandDropdown = true;
    disableDosageDropdown = true;
    disableStrengthDropdown = true;
    disableQuantityInput = true;
    lookedForPrice = false;

    accessToken: string;

    ngOnInit() {
        this.accessToken = this.master.accessToken;
        this.drugNameDataManager = new DataManager({
            url: 'Service/Drug/Names',
            adaptor: new WebApiAdaptor,
            crossDomain: true,
            headers: [{ 'accesstoken': this.accessToken }]
        });
    }

    // maps the appropriate column to fields property
    public drugNameField: Object = { value: 'drugName', ndc: 'ndc' };
    // bind the Query instance to query property
    public drugNameQuery: Query = new Query().select(['drugName']).take(6);
    // sort the result items
    public sorting = 'Ascending';
    public brandData: { [key: string]: Object }[];
    public brandFields: Object = { text: 'displayName', value: 'id' };
    public dosageData: { [key: string]: Object }[];
    public dosageFields: Object = { text: 'displayName', value: 'id' };
    public typeData: { [key: string]: Object }[];
    public strengthFields: Object = { text: 'strength', value: 'id' };
    public drugNameDataManager: DataManager;
    // endregion

    // region IO Properties
    @Output() drugReset: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() drugPricingRequested: EventEmitter<DrugPricing> = new EventEmitter<DrugPricing>();
    @Output() drugLookupChanged: EventEmitter<DrugLookup> = new EventEmitter<DrugLookup>();

    // endregion

    // region Event Handlers

    getDrugPrices() {
        this.getDrugPricingRequest();
        this.lookedForPrice = true;
    }
    drugNameAC: string;
    onDrugSearchMouseUp(event) {
        if (this.drugNameAC === null) {
            this.resetDrugSearchFields();
        }
    }



    onDrugNameSelected(event) {
        if (event.item) {
            this.ndc = event.itemData.ndc;
            this.drugName = event.item.innerText;
            this.drugNameAutoComplete.value = '';
            this.brandData = [];
            this.disableBrandDropdown = true;
            this.dosageData = [];
            this.disableDosageDropdown = true;
            this.typeData = [];
            this.disableStrengthDropdown = true;
            this.quantityTB.nativeElement.value = '';
            this.disableQuantityInput = true;
            this.lookedForPrice = false;

            let drugIndex = 0;

            if (this.ndc === null) {
                this.drugLookupServiceInterface.getDrug(this.drugName)
                    .subscribe(resp => {
                        this.drug = this.mapDrug(drugIndex++, resp);
                        this.brands = this.drug.brand;
                        let brandIndex = 0;
                        this.brandData = this.brands.map(brand => {
                            const displayName = `${brand.name} (${brand.type})`;
                            return { displayName, id: brandIndex++ };
                        });
                    });
            } else {
                this.drugLookupServiceInterface.getDrugByNDC(this.ndc)
                    .subscribe(resp => {
                        this.drug = this.mapDrug(drugIndex++, resp);
                        this.brands = this.drug.brand;
                        let brandIndex = 0;
                        this.brandData = this.brands.map(brand => {
                            const displayName = `${brand.name} (${brand.type})`;
                            return { displayName, id: brandIndex++ };
                        });

                        if (this.brandData.length == 1) {
                            this.brandDDL.index = 0;
                        }
                    });
            }

            this.drugReset.emit(true);
            this.disableBrandDropdown = false;
            this.disableDosageDropdown = true;
            this.disableStrengthDropdown = true;
            this.disableQuantityInput = true;
            this.lookedForPrice = false;
        }
    }

    onBrandSelected(event) {
        if (event.item) {
            this.brand = this.brands[event.item.id].name;
            this.dosageData = [];
            this.disableDosageDropdown = true;
            this.typeData = [];
            this.disableStrengthDropdown = true;
            this.quantityTB.nativeElement.value = '';
            this.disableQuantityInput = true;
            this.lookedForPrice = false;
            this.dosages = this.brands[event.item.id].form;
            let dosageIndex = 0;
            this.dosageData = this.dosages.map(form => {
                const displayName = form.form;
                return { displayName, id: dosageIndex++ };
            });
            this.disableBrandDropdown = false;
            this.disableDosageDropdown = false;
            this.disableStrengthDropdown = true;
            this.disableQuantityInput = true;
            this.lookedForPrice = false;

            if (this.dosageData.length == 1) {
                this.dosageDDL.index = 0;
            }
        }
    }

    onDosageSelected(event) {
        if (event.item) {
            this.types = this.dosages[event.item.id].type;
            this.quantityTB.nativeElement.value = '';
            this.disableQuantityInput = true;
            this.typeData = this.types.map(type => {
                const strength = `${type.strength}`;
                return { strength, id: type.id };
            });//.sort((a, b) => parseInt(a.strength, 10) > parseInt(b.strength, 10) ? 1 : -1);
            this.quantity = null;
            this.disableBrandDropdown = false;
            this.disableDosageDropdown = false;
            this.disableStrengthDropdown = false;
            this.disableQuantityInput = true;
            this.lookedForPrice = false;

            if (this.typeData.length == 1) {
                this.strengthDDL.index = 0;
            }
        }
    }

    onStrengthSelected(event) {
        if (event.item) {
            this.typeId = event.item.id;
            this.strength = this.types[this.typeId].strength;
            this.ndc = this.types[this.typeId].ndc;
            this.npi = this.types[this.typeId].npi;
            this.awpUnitPrice = this.types[this.typeId].awpUnitPrice;
            this.packageSize = this.types[this.typeId].packageSize;
            this.quantity = null;
            this.drugReset.emit(true);
            this.disableBrandDropdown = false;
            this.disableStrengthDropdown = false;
            this.disableStrengthDropdown = false;
            this.disableQuantityInput = false;
            this.lookedForPrice = false;
        }
    }

    onQuantityChanged(e) {
        this.quantity = e;
        this.drugReset.emit(true);
    }

    resetDrugSearchFields() {
        this.drugNameAutoComplete.value = '';
        this.brandData = [];
        this.disableBrandDropdown = true;
        this.dosageData = [];
        this.disableDosageDropdown = true;
        this.typeData = [];
        this.disableStrengthDropdown = true;
        this.quantityTB.nativeElement.value = '';
        this.disableQuantityInput = true;
        this.lookedForPrice = false;
        this.drugReset.emit(true);
    }
    // endregion
    // region Methods
    getDrugPricingRequest() {
        if (this.quantity > 0) {
            const drugPricing = new DrugPricing();
            drugPricing.clientId = '0';
            drugPricing.ndc = this.ndc;
            drugPricing.npi = this.npi;
            drugPricing.quantity = this.quantity * this.packageSize;
            drugPricing.awpUnitPrice = this.awpUnitPrice;
            drugPricing.cardholderId = this.cardholderId;
            drugPricing.groupId = this.groupId;
            this.drugPricingRequested.emit(drugPricing);

            const drugLookup = new DrugLookup();
            drugLookup.brand = this.brand;
            drugLookup.strength = this.strength;
            drugLookup.quantity = this.quantity;
            this.drugLookupChanged.emit(drugLookup);
        }
    }

    private mapDrug(drugIndex: number, json: any) {
        const drug = new Drug();
        const r = JSON.parse(json);
        drug['id'] = r.id || drugIndex;
        let brandIndex = 0;
        drug.brand = r.brand.map(b => {
            return this.mapBrands(brandIndex++, b);
        });
        return drug;
    }

    private mapBrands(brandIndex: number, b: any) {
        const brand = new Brand();
        // brand.id = b.id || brandIndex++;
        brand.name = b.name;
        brand.type = b.type;
        let formIndex = 0;
        brand.form = b.form.map(f => {
            return this.mapForms(formIndex++, f);
        });
        return brand;
    }

    private mapForms(formIndex: number, f: any) {
        const dosage = new Dosage();
        dosage['id'] = f.id || formIndex;
        let drugInformationIndex = 0;
        dosage.form = f.form;
        dosage.type = f.type.map(t => {
            return this.mapDrugInformation(drugInformationIndex++, t);
        });
        return dosage;
    }

    private mapDrugInformation(drugInformationIndex: number, t: any) {
        const type = new FormType();
        type['id'] = t.id || drugInformationIndex;
        type.ndc = t.ndc;
        type.strength = t.strength;
        type.awpUnitPrice = t.awpUnitPrice;
        type.packageSize = t.packageSize; 
        return type;
    }
    // endregion
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/drug-lookup/drug-lookup.component.ts